module.exports = __webpack_public_path__ + "img/404Robot.d743335.png";